import React from "react";
import { X, ClipboardList, Clock, User } from "lucide-react";

const CustomerLogsModal = ({ isOpen, onClose, customerName, logs }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full max-h-[85vh] overflow-hidden flex flex-col animate-in fade-in zoom-in duration-200">
        
        {/* Header */}
        <div className="p-5 border-b dark:border-gray-700 flex justify-between items-center bg-amber-50 dark:bg-gray-900/50">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-100 dark:bg-amber-900/40 rounded-lg">
              <ClipboardList className="w-5 h-5 text-amber-600 dark:text-amber-400" />
            </div>
            <div>
              <h3 className="font-bold text-gray-800 dark:text-white leading-tight">
                Ingresos Semanales
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400">{customerName}</p>
            </div>
          </div>
          <button 
            onClick={onClose} 
            className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-full transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        {/* Body */}
        <div className="p-5 overflow-y-auto space-y-4 custom-scrollbar">
          {logs && logs.length > 0 ? (
            <div className="space-y-3">
              {logs.map((log, index) => (
                <div 
                  key={index} 
                  className="group relative p-4 bg-gray-50 dark:bg-gray-700/50 rounded-xl border border-gray-100 dark:border-gray-600 hover:border-amber-200 dark:hover:border-amber-900/50 transition-all shadow-sm"
                >
                  <div className="flex items-start gap-3">
                    <div className="mt-1">
                      <User className="w-4 h-4 text-gray-400" />
                    </div>
                    <div className="flex-1">
                      <p className="text-sm font-semibold text-gray-700 dark:text-gray-200 break-all">
                        {log.email}
                      </p>
                      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2">
                        <span className="inline-flex items-center text-[11px] font-medium px-2 py-0.5 rounded-full bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300">
                          {log.role}
                        </span>
                        <span className="inline-flex items-center gap-1 text-[11px] text-blue-600 dark:text-blue-400 font-mono font-bold">
                          <Clock className="w-3 h-3" />
                          {new Date(log.date).toLocaleString('es-ES', { 
                            day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' 
                          })} hs
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <div className="w-16 h-16 bg-gray-100 dark:bg-gray-700/50 rounded-full flex items-center justify-center mb-4">
                <ClipboardList className="w-8 h-8 text-gray-300 dark:text-gray-600" />
              </div>
              <p className="text-gray-500 dark:text-gray-400 font-medium">No se registraron ingresos</p>
              <p className="text-xs text-gray-400">En el periodo seleccionado</p>
            </div>
          )}
        </div>
        
        {/* Footer */}
        <div className="p-4 border-t dark:border-gray-700 bg-gray-50 dark:bg-gray-900/30 flex justify-end">
          <button 
            onClick={onClose}
            className="px-5 py-2 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-200 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-600 transition-all text-sm font-bold shadow-sm"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerLogsModal;